import { modelServices } from '@/app/shared/services/client-agent-service.js';
import { httpClient } from '@/app/shared/services/http-client/http-client.js';

export class RSDNotificationService {
    constructor() {}
    getRSDNotificationList() {
        return modelServices.baseUrl + modelServices.getInventoryManagementOdataServiceName("getRSDNotificationODataUrl").URL;
    }
    getRSDNotificationDDL(callback) {
        return httpClient.get(modelServices.baseUrl + modelServices.getInventoryManagementServiceName("getRSDNotificationDDL").URL).then(callback);
    }
    AddRSDNotification(param, callback) {
        const url = modelServices.getInventoryManagementServiceName("AddRSDNotification").URL;
        const options = {
            url: url,
            method: 'POST',
            headers: { 'content-type': 'application/json; charset=utf-8' },
            data: JSON.stringify(param)
        };
        httpClient(options).then(callback)
    }
    GetRSDTransactionsErrors(param,param2, callback) {
        const url = modelServices.getInventoryManagementServiceName("GetRSDTransactionsErrors").URL;
        const options = {
            url: url,
            method: 'POST',
            headers: { 'content-type': 'application/json; charset=utf-8' },
            params: {notificationID:param,TransactionTypeID:param2}
        };
        httpClient(options).then(callback)
    }

/*     getProductDetails(param, callback) {
        var url = modelServices.baseUrl + modelServices.getInventoryManagementServiceName("GetProductDetailsForLoction").URL;
        return httpClient.get(url, { params: param }).then(callback);
    } */
}

const rsdNotificationService = new RSDNotificationService();
export { rsdNotificationService };

